// axiosInstance.js
import axios from "axios";

// Create the axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Default API URL
  headers: {
    "Content-Type": "application/json", // Default content type
  },
});

// Add a request interceptor to automatically attach the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken"); // Or wherever you store your token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Bypass ngrok browser warning page for local development
    config.headers["ngrok-skip-browser-warning"] = "true";
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
